<template>
    <div class="container section">
        <div class="row heading">
            <div class="col-3">

                <h2>Carrier Information</h2>
            </div>
            <div class="col text-right" v-show="editing">
                <button @click="save" class="btn btn-sm btn-success">
                    <i class="fa fa-check"></i> &nbsp;Save
                </button>
                <button @click="cancel" class="btn btn-sm btn-danger">
                    <i class="fa fa-remove"></i> &nbsp;Cancel
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-2 col-form-label"><label>Name</label></div>
            <div class="col-4" @click="editFields('name')" >
                <div class="col-form-label"  v-show="!editing">
                    {{carrierDetails.name}}
                    <i  v-if="$canAccess(21,23)" class="editable-icon float-right fa fa-pencil text-muted"> </i>
                </div>
                    <span v-show="editing">
                        <input class="form-control"
                               type="text"
                               v-model="selected.name"
                        />
                    </span>
            </div>
        </div>

        <div class="row">
            <div class="col col-form-label text-truncate"><label>Commissions Rate</label></div>
            <div class="col-md-4 editable col-form-label" @click="editFields('commsrate')" >
                <div v-show="!editing" >
                    {{ carrierDetails.commsrate  }}
                    <i  v-if="$canAccess(21,23)" class="editable-icon float-right fa fa-pencil text-muted"></i>
                </div>
                <span v-show="editing" >
                    <div class="input-group">
                        <input class="form-control"
                               type="text"
                               v-model="selected.commsrate"
                        />
                    </div>
                </span>

            </div>
            <div class="col col-form-label text-truncate"><label>Spiff Rate</label></div>
            <div class="col-md-4 editable col-form-label" @click="editFields('spiffrate')" >
                <div v-show="!editing" >
                    {{ carrierDetails.spiffrate  }}
                    <i v-if="$canAccess(21,23)" class="editable-icon float-right fa fa-pencil text-muted"></i>
                </div>
                <span v-show="editing" >
                    <div class="input-group">
                        <input class="form-control"
                               type="text"
                               v-model="selected.spiffrate"
                        />
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">

    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        name: 'carrierInformation',
        data: function () {
            return {
                carrierDetails: [],
                editing: false,
                selected: {
                    name: '',
                    commsrate: '',
                    spiffrate: ''
                }
            }
        },
        mixins: [clickaway],
        created(){
            this.fetchData();
        },
        directives: {
            'input-focus': function (el, value) {
                if (value) {
                    el.focus()
                }
            }
        },
        props: ['carrier_id'],
        methods: {
            fetchData(){

                this.$send(this, 'carrierDetails', {
                    carrier_id: this.carrier_id
                }).then(r => {
                    this.carrierDetails = r.carrierDetails;
                });

            },
            save(){
                var data = JSON.parse(JSON.stringify(this.selected));
                data.carrier_id = this.carrier_id;


                this.$send(this, 'carrierUpdate', data).then(r => {
                    this.fetchData();
                    this.cancel();
                });

            },
            cancel(){
                this.editing = null;
                this.selected = {}
            },
            editFields(field){
                if (!this.editing && this.$canAccess(21,23)) {
                    this.editing = field;
                    this.selected = JSON.parse(JSON.stringify(this.carrierDetails));
                }
            }
        }
    }
</script>
<style scoped>
    .editable-icon{
        display:none;
    }
    .editable{
        cursor:pointer;
    }
    .editable:hover .editable-icon{
        display:block;
    }
</style>


// WEBPACK FOOTER //
// CarrierInformation.vue?20ae76e8